<template>
  <div id="contenedor-agregar-detalle">
    <v-form
      v-model="formularioValido"
      ref="agregarDetallesSolicitud">
      <v-row>
        <v-col
          cols="12">
          <seleccionar-referencia
            v-model="detalle.idReferencia"
            :items="referencias"
            label="Seleccionar referencia"
            @change="setImporteDetalle">
          </seleccionar-referencia>
        </v-col>
        <v-col
          cols="12">
          <v-divider></v-divider>
        </v-col>
        <custom-text-field
          v-model="detalle.numeroFactura"
          label="Número de factura"
          cols="12"
          md="6"
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <date-picker
          v-model="detalle.fechaFactura"
          label="Fecha factura"
          cols="12"
          md="6"
          :rules="[mixReglas.requerido]">
        </date-picker>
        <custom-text-field-green
          cols="12"
          v-model.number="detalle.importe"
          label="Importe"
          es-dinero
          prefix="$"
          :rules="[mixReglas.requerido, reglas.mayorCero]">
        </custom-text-field-green>
      </v-row>
        <v-row>
          <v-col>
            <v-row justify="center">
              <v-btn
                depressed
                rounded
                :color="detalle.archivoPdf ? 'success' : 'secondary'"
                @click="$refs.seleccionarAnexoPdf.click()">
                <v-icon class="mx-2"> fa-file-pdf </v-icon>
                PDF
              </v-btn>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="center">
              <v-btn
                depressed
                rounded
                :color="detalle.archivoXml ? 'success' : 'secondary'"
                @click="$refs.seleccionarAnexoXml.click()">
                <v-icon class="mx-2"> fa-file-code </v-icon>
                XML
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
        </v-row>
    </v-form>
    <input
      type="file"
      ref="seleccionarAnexoPdf"
      id="anexoPdf"
      class="d-none"
      accept=".pdf"
      @change="seleccionPdf">
      <input
      type="file"
      ref="seleccionarAnexoXml"
      id="anexoXml"
      class="d-none"
      accept=".xml"
      @change="seleccionXml">
  </div>
</template>

<script>
import SeleccionarReferencia from './SeleccionarReferencia.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';

export default {
  name: 'AgregarSolicitudDetalle',
  props: {
    referencias: {
      type: Array,
      required: true,
    },
    referenciasSeleccionadas: {
      type: Array,
      required: true,
    },
  },
  components: {
    SeleccionarReferencia,
    CustomTextField,
    DatePicker,
    CustomTextFieldGreen,
  },
  data() {
    return {
      formularioValido: false,
      mostrarAgregarArchivos: false,
      reglas: {
        mayorCero: (val) => {
          const valor = Number(String(val).replace(/\D/g, ''));
          return valor > 0 || 'El monto debe de ser mayor a 0.';
        },
      },
      detalle: {
        idReferencia: '',
        numeroFactura: '',
        fechaFactura: '',
        importe: 0,
        archivoPdf: null,
        archivoXml: null,
      },
      detalles: [],
    };
  },
  methods: {
    setImporteDetalle() {
      this.detalle.importe = this.getReferenciaSeleccionada.total;
    },
    agregar() {
      this.detalle.referencia = this.getReferenciaSeleccionada;
      const nuevoDetalle = { ...this.detalle };

      this.referenciasSeleccionadas.push(nuevoDetalle);
      this.limpiarFormulario();
    },
    limpiarFormulario() {
      this.detalle.archivoPdf = null;
      this.detalle.archivoXml = null;
      this.$refs.agregarDetallesSolicitud.reset();
    },
    seleccionPdf() {
      const archivo = document.getElementById('anexoPdf').files[0];
      this.detalle.archivoPdf = archivo;
    },
    seleccionXml() {
      const archivo = document.getElementById('anexoXml').files[0];
      this.detalle.archivoXml = archivo;
    },
  },
  computed: {
    getReferenciaSeleccionada() {
      return this.referencias
        .find(({ id }) => id === this.detalle.idReferencia);
    },
  },
};
</script>

<style lang="scss">

</style>
